module.exports = __webpack_public_path__ + "media/images/firsttime_contents03_pc-7d7a2ae5470567ca7c29d5054f102b5c.png";